import { type AskPunttChatUserSummary } from "@mg/schemas/src/christo/askPuntt";
import { type AskPunttProjectListItem } from "@mg/schemas/src/christo/askPunttProject";

export function projectMemberLabel(member: AskPunttChatUserSummary): string {
  return member.name?.trim() || member.email?.trim() || "Member";
}

/** Unique members across projects (for the participant filter dropdown). */
export function collectUniqueProjectMembers(
  projects: AskPunttProjectListItem[],
): AskPunttChatUserSummary[] {
  const map = new Map<string, AskPunttChatUserSummary>();
  for (const project of projects) {
    for (const member of project.members ?? []) {
      if (!map.has(member._id)) map.set(member._id, member);
    }
  }
  return Array.from(map.values()).sort((a, b) =>
    projectMemberLabel(a).localeCompare(projectMemberLabel(b)),
  );
}
